/* Barra fija de compra (móvil) · Zucchiini · 22/10/2026
 *
 * Qué hace
 * - Muestra una barra fija abajo cuando el botón principal de compra sale de pantalla por
 *   arriba (IntersectionObserver) y la oculta cuando vuelve a verse. Solo < 750 px.
 * - NUNCA añade al carrito por su cuenta (nada de fetch a /cart/add): pulsa el botón principal
 *   de la ficha. Así se conservan el selector de packs nativo («Elige tu pack», que intercepta
 *   ese clic y añade unidades + regalo), los eventos de AnyTrack / Meta / Google y el cajón.
 * - La ficha preselecciona la PRIMERA talla disponible (Horizon) y el pack «Top ventas».
 *   Para no añadir una talla que el cliente no eligió: si no ha tocado la talla en esta visita,
 *   el botón abre un panel inferior con pack, color y talla. Ese panel maneja los selectores
 *   REALES de la ficha (clic en sus radios), espera a que el tema actualice la variante y
 *   entonces pulsa el botón principal.
 *
 * Textos: los del botón vienen de Liquid (ajustes del tema); los de aquí, por
 * document.documentElement.lang (español por defecto).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-zs]');
  if (!root || root.__zs) return;
  root.__zs = true;

  var data;
  try {
    data = JSON.parse(root.querySelector('[data-zs-data]').textContent);
  } catch (e) {
    return;
  }

  var I18N = {
    es: {
      chooseSize: 'Elige tu talla',
      chooseToContinue: 'Elige tu talla para continuar',
      size: 'Talla',
      color: 'Color',
      pack: 'Elige tu pack',
      mixed: 'Pack combinado',
      retry: 'No se pudo actualizar la talla. Inténtalo de nuevo.',
      sizeGuide: '¿Cuál es mi talla?',
      units: function (n) { return n + (n === 1 ? ' ud' : ' uds'); },
    },
    en: {
      chooseSize: 'Choose your size',
      chooseToContinue: 'Choose your size to continue',
      size: 'Size',
      color: 'Color',
      pack: 'Choose your pack',
      mixed: 'Mixed pack',
      retry: 'Could not update the size. Please try again.',
      sizeGuide: 'What is my size?',
      units: function (n) { return n + (n === 1 ? ' pc' : ' pcs'); },
    },
  };
  var lang = (document.documentElement.lang || 'es').toLowerCase().slice(0, 2);
  var T = I18N[lang] || I18N.es;

  var SIZE_RE = /talla|size|taille|tama[nñ]o|gr[oö](ss|ß)e/i;
  var COLOR_RE = /colou?r|couleur|farbe/i;
  var sizeIdx = -1;
  var colorIdx = -1;
  data.options.forEach(function (name, i) {
    if (sizeIdx < 0 && SIZE_RE.test(name)) sizeIdx = i;
    else if (colorIdx < 0 && COLOR_RE.test(name)) colorIdx = i;
  });

  var mq = window.matchMedia('(max-width: 749px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var html = document.documentElement;
  var bar = root.querySelector('[data-zs-bar]');
  var sheet = root.querySelector('[data-zs-sheet]');
  var addBtn = root.querySelector('[data-zs-add]');
  var addLabel = root.querySelector('[data-zs-add-label]');
  var cta = root.querySelector('[data-zs-cta]');
  var ctaLabel = root.querySelector('[data-zs-cta-label]');
  var ctaPrice = root.querySelector('[data-zs-cta-price]');
  var hint = root.querySelector('[data-zs-hint]');
  var sizeGroup = root.querySelector('[data-zs-group="size"]');

  var state = {
    sizeChosen: sizeIdx < 0, // sin opción de talla → la selección ya está completa
    inView: true, // el botón principal está en pantalla (o aún no se ha llegado a él)
    typing: false,
    busy: false,
  };

  /* ── Localizar las piezas REALES de la ficha ─────────────────────────── */
  function inCard(el) {
    return !!(el && el.closest('product-card, quick-add-dialog, quick-add-component, swatches-variant-picker-component'));
  }
  function productForm() {
    var all = document.querySelectorAll('main product-form-component');
    for (var i = 0; i < all.length; i++) {
      if (!inCard(all[i]) && String(all[i].dataset.productId) === String(data.productId)) return all[i];
    }
    return null;
  }
  function mainButton() {
    var pf = productForm();
    return pf && pf.querySelector('button.add-to-cart-button, [ref="addToCartButton"], button[name="add"]');
  }
  function picker() {
    var all = document.querySelectorAll('main variant-picker');
    for (var i = 0; i < all.length; i++) {
      if (!inCard(all[i]) && String(all[i].dataset.productId) === String(data.productId)) return all[i];
    }
    return null;
  }
  function packWidget() {
    var w = document.querySelector('main [data-zb]');
    return w && !inCard(w) ? w : null;
  }
  function formVariantId() {
    var pf = productForm();
    var input = pf && pf.querySelector('input[name="id"]');
    return input ? String(input.value) : '';
  }
  function variantById(id) {
    for (var i = 0; i < data.variants.length; i++) if (String(data.variants[i].id) === String(id)) return data.variants[i];
    return null;
  }
  function variantByOpts(opts) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var ok = true;
      for (var j = 0; j < opts.length; j++) if (String(v.o[j]) !== String(opts[j])) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }
  function currentVariant() {
    return variantById(formVariantId()) || variantById(data.variants[0] && data.variants[0].id);
  }
  /* Radios del selector del tema para la opción idx */
  function pickerInputs(idx) {
    var p = picker();
    if (!p) return [];
    var fs = p.querySelector('fieldset[data-fieldset-index="' + idx + '"]');
    return fs ? Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')) : [];
  }
  /* Variante que el cliente tiene marcada en el selector (se actualiza al instante;
     el formulario va unos ms por detrás mientras el tema pide la sección) */
  function expectedVariant() {
    var cur = currentVariant();
    if (!cur) return null;
    var opts = cur.o.slice();
    for (var i = 0; i < opts.length; i++) {
      var checked = pickerInputs(i).filter(function (r) { return r.checked; })[0];
      if (checked) opts[i] = checked.value;
    }
    return variantByOpts(opts) || cur;
  }
  function packQty() {
    var w = packWidget();
    var on = w && w.querySelector('[data-zb-opt][data-on="true"]');
    return on ? Number(on.getAttribute('data-qty')) || 1 : 1;
  }
  function text(el) {
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }
  /* Precio que ve el cliente: el del pack elegido si hay selector de packs; si no, el del bloque de precio */
  function readPrice() {
    var w = packWidget();
    if (w) {
      var on = w.querySelector('[data-zb-price][data-on="true"]');
      if (on) return { now: text(on.querySelector('.zb-total')), was: text(on.querySelector('.zb-was')) };
    }
    var pp = null;
    var all = document.querySelectorAll('main product-price');
    for (var i = 0; i < all.length; i++) if (!inCard(all[i])) { pp = all[i]; break; }
    return { now: text(pp && pp.querySelector('.price')), was: text(pp && pp.querySelector('.compare-at-price')) };
  }
  function selectionText() {
    if (!state.sizeChosen) return { text: T.chooseSize, missing: true };
    var v = currentVariant();
    // pack con unidades configuradas a mano en el selector de packs
    var w = packWidget();
    var slots = w ? w.querySelectorAll('[data-zb-slots] .zb-slot') : [];
    if (slots.length > 1) {
      var combos = {};
      var first = '';
      Array.prototype.forEach.call(slots, function (s) {
        var k = Array.prototype.map.call(s.querySelectorAll('select'), function (x) { return x.value; }).join(' · ');
        if (!first) first = k;
        combos[k] = true;
      });
      if (Object.keys(combos).length > 1) return { text: T.mixed, missing: false };
      if (first) return { text: first, missing: false };
    }
    if (!v) return { text: '', missing: false };
    return {
      text: v.o.filter(function (x) { return x && x !== 'Default Title'; }).join(' · '),
      missing: false,
    };
  }

  /* ── Pintar barra y panel ─────────────────────────────────────────────── */
  function setImg(src) {
    if (!src) return;
    root.querySelectorAll('[data-zs-img]').forEach(function (img) {
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
    });
  }

  function refresh() {
    var v = currentVariant();
    var price = readPrice();
    var sel = selectionText();
    var qty = packQty();
    var btn = mainButton();
    var soldOut = !!(v && !v.av);

    if (v) setImg(v.img);
    root.querySelectorAll('[data-zs-price]').forEach(function (el) { el.textContent = price.now; });
    root.querySelectorAll('[data-zs-was]').forEach(function (el) { el.textContent = price.was; });
    root.querySelectorAll('[data-zs-sel]').forEach(function (el) {
      el.textContent = sel.text;
      if (sel.missing) el.setAttribute('data-missing', '');
      else el.removeAttribute('data-missing');
    });
    root.querySelectorAll('[data-zs-qty]').forEach(function (el) {
      el.textContent = '×' + qty;
      el.hidden = qty < 2;
    });

    // botón de la barra: desactivado solo si la variante está agotada (o no hay botón principal)
    if (!state.busy) {
      addBtn.disabled = !btn || soldOut;
      addLabel.textContent = soldOut ? data.soldOut : data.label;
    }

    // botón del panel: «Elige tu talla» (aria-disabled, al pulsarlo señala las tallas),
    // «Agotado» (disabled) o «Añadir al carrito · precio»
    if (!cta.hasAttribute('aria-busy')) {
      var target = expectedVariant() || v;
      var targetSold = !!(target && !target.av);
      cta.disabled = !btn || targetSold;
      if (targetSold) {
        ctaLabel.textContent = data.soldOut;
        ctaPrice.textContent = '';
        cta.removeAttribute('aria-disabled');
      } else if (!state.sizeChosen) {
        ctaLabel.textContent = T.chooseSize;
        ctaPrice.textContent = '';
        cta.setAttribute('aria-disabled', 'true');
      } else {
        ctaLabel.textContent = data.sheetLabel;
        ctaPrice.textContent = price.now;
        cta.removeAttribute('aria-disabled');
      }
    }

    if (sheet.open) renderOptions();
    updateVisibility();
  }

  var refreshQueued = false;
  function queueRefresh() {
    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(function () {
      refreshQueued = false;
      refresh();
    });
  }

  /* Opciones del panel: pack (espejo de «Elige tu pack»), color y talla */
  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  var lastSig = '';
  function renderOptions(force) {
    var cur = expectedVariant() || currentVariant();
    if (!cur) return;
    var w = packWidget();
    var opts = w ? w.querySelectorAll('[data-zb-opt]') : [];
    // Solo se reconstruye si cambia algo (otros scripts mutan la ficha cada segundo:
    // reconstruir los botones en mitad de un toque perdería el clic).
    var sig = [cur.id, state.sizeChosen, packQty(), opts.length, !!document.querySelector('main .smartsize-trigger')].join('|');
    if (!force && sig === lastSig) return;
    lastSig = sig;

    // PACK
    var packGroup = root.querySelector('[data-zs-group="pack"]');
    var packList = root.querySelector('[data-zs-list="pack"]');
    packGroup.hidden = opts.length < 2;
    if (opts.length > 1) {
      root.querySelector('[data-zs-legend="pack"]').textContent = T.pack;
      packList.textContent = '';
      Array.prototype.forEach.call(opts, function (opt) {
        var q = Number(opt.getAttribute('data-qty')) || 1;
        var on = opt.getAttribute('data-on') === 'true';
        var b = el('button', 'zs-seg__i', { type: 'button', role: 'radio', 'aria-checked': on ? 'true' : 'false' });
        var n = el('span', 'zs-seg__n');
        n.textContent = T.units(q);
        var d = el('span', 'zs-seg__d');
        d.textContent = text(opt.querySelector('.zb-d'));
        b.appendChild(n);
        b.appendChild(d);
        b.addEventListener('click', function () {
          opt.click(); // el propio selector de packs del tema cambia el pack
          queueRefresh();
        });
        packList.appendChild(b);
      });
    }

    // COLOR
    var colorGroup = root.querySelector('[data-zs-group="color"]');
    var colorList = root.querySelector('[data-zs-list="color"]');
    var colors = colorIdx >= 0 ? data.values[colorIdx] || [] : [];
    colorGroup.hidden = colors.length < 2 || !pickerInputs(colorIdx).length;
    if (!colorGroup.hidden) {
      var legend = root.querySelector('[data-zs-legend="color"]');
      legend.textContent = T.color + ' · ';
      var b0 = document.createElement('b');
      b0.textContent = cur.o[colorIdx];
      legend.appendChild(b0);
      colorList.textContent = '';
      colors.forEach(function (c) {
        var on = String(cur.o[colorIdx]) === String(c);
        var opts2 = cur.o.slice();
        opts2[colorIdx] = c;
        var v = variantByOpts(opts2);
        if (!v) {
          for (var i = 0; i < data.variants.length; i++) if (data.variants[i].o[colorIdx] === c) { v = data.variants[i]; break; }
        }
        var b = el('button', 'zs-sw', { type: 'button', role: 'radio', 'aria-checked': on ? 'true' : 'false', 'aria-label': c, title: c });
        if (v && v.img) {
          var img = el('img', '', { src: v.img, alt: '', width: '48', height: '60', loading: 'lazy', decoding: 'async' });
          b.appendChild(img);
        }
        b.addEventListener('click', function () {
          choose(colorIdx, c);
        });
        colorList.appendChild(b);
      });
    }

    // TALLA
    var sizeList = root.querySelector('[data-zs-list="size"]');
    var sizes = sizeIdx >= 0 ? data.values[sizeIdx] || [] : [];
    sizeGroup.hidden = sizes.length < 1 || !pickerInputs(sizeIdx).length;
    if (!sizeGroup.hidden) {
      root.querySelector('[data-zs-legend="size"]').textContent = T.size;
      var guide = root.querySelector('[data-zs-guide]');
      var trigger = document.querySelector('main .smartsize-trigger');
      guide.hidden = !trigger;
      guide.textContent = T.sizeGuide;
      sizeList.textContent = '';
      sizes.forEach(function (s) {
        var opts3 = cur.o.slice();
        opts3[sizeIdx] = s;
        var v = variantByOpts(opts3);
        var available = !!(v && v.av);
        var on = state.sizeChosen && String(cur.o[sizeIdx]) === String(s);
        var b = el('button', 'zs-size', { type: 'button', role: 'radio', 'aria-checked': on ? 'true' : 'false' });
        if (!available) b.setAttribute('aria-disabled', 'true');
        b.textContent = s;
        b.addEventListener('click', function () {
          if (!available) return;
          state.sizeChosen = true;
          hint.textContent = '';
          choose(sizeIdx, s);
        });
        sizeList.appendChild(b);
      });
    }
  }

  /* Elegir un valor = pulsar el radio REAL del selector del tema (él pide la sección,
     actualiza el formulario, la galería, el precio y el selector de packs). */
  function choose(idx, value) {
    var input = pickerInputs(idx).filter(function (r) { return r.value === String(value); })[0];
    if (!input) {
      // por si el selector cambiara de formato: llevar al cliente al selector de la ficha
      closeSheet(true);
      var p = picker();
      if (p) p.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
      return;
    }
    if (!input.checked) input.click();
    queueRefresh();
  }

  /* ── Aparición: IntersectionObserver sobre los botones de compra de la ficha ── */
  var io = null;
  var observed = null;
  function observe() {
    var pf = productForm();
    var target = pf && (pf.querySelector('.product-form-buttons') || mainButton());
    if (!target || target === observed) return;
    if (io) io.disconnect();
    observed = target;
    io = new IntersectionObserver(
      function (entries) {
        var e = entries[entries.length - 1];
        // visible en pantalla, o todavía por debajo (aún no se ha llegado a él) → sin barra
        var below = e.boundingClientRect.top > (e.rootBounds ? e.rootBounds.bottom : window.innerHeight);
        state.inView = e.isIntersecting || below;
        updateVisibility();
      },
      { rootMargin: '-64px 0px 0px 0px', threshold: 0 } // 64 px ≈ cabecera fija
    );
    io.observe(target);
  }

  var lastVisible = null;
  function updateVisibility() {
    var show = mq.matches && !state.inView && !state.typing && !!mainButton();
    if (show === lastVisible) return;
    lastVisible = show;
    bar.classList.toggle('is-visible', show);
    html.classList.toggle('zs-visible', show);
    if (show) {
      bar.removeAttribute('aria-hidden');
      bar.removeAttribute('inert');
    } else {
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
    }
  }

  // altura de la barra → CSS (para subir el botón «volver arriba» justo encima)
  if (window.ResizeObserver) {
    new ResizeObserver(function () {
      html.style.setProperty('--zs-h', bar.offsetHeight + 'px');
    }).observe(bar);
  }

  /* ── Añadir: siempre a través del botón principal ─────────────────────── */
  function waitFor(cond, timeout) {
    return new Promise(function (resolve) {
      var t0 = Date.now();
      (function tick() {
        var ok = false;
        try { ok = cond(); } catch (e) {}
        if (ok) return resolve(true);
        if (Date.now() - t0 > timeout) return resolve(false);
        setTimeout(tick, 60);
      })();
    });
  }
  function inSync() {
    var b = mainButton();
    var exp = expectedVariant();
    return !!(b && !b.disabled && (!exp || formVariantId() === String(exp.id)));
  }

  var busyTimer = null;
  function setBusy(on) {
    state.busy = on;
    clearTimeout(busyTimer);
    if (on) {
      addBtn.setAttribute('aria-busy', 'true');
      busyTimer = setTimeout(function () { setBusy(false); }, 6000);
    } else {
      addBtn.removeAttribute('aria-busy');
      cta.removeAttribute('aria-busy');
      queueRefresh();
    }
  }

  function clickMain() {
    var b = mainButton();
    if (!b || b.disabled) return false;
    setBusy(true);
    // Mismo clic que el del cliente en el botón de la ficha: lo recoge el selector de packs
    // (gancho de captura en theme.liquid) o, sin packs, el submit del product-form del tema.
    b.click();
    return true;
  }

  function addFromBar() {
    if (state.busy) return;
    if (!state.sizeChosen) {
      openSheet();
      return;
    }
    var v = currentVariant();
    if (v && !v.av) return;
    setBusy(true);
    waitFor(inSync, 4000).then(function (ok) {
      state.busy = false;
      if (!ok || !clickMain()) {
        setBusy(false);
        openSheet();
      }
    });
  }

  function addFromSheet() {
    if (cta.hasAttribute('aria-busy') || cta.disabled) return;
    if (!state.sizeChosen) {
      hint.textContent = T.chooseToContinue;
      sizeGroup.classList.remove('is-attention');
      void sizeGroup.offsetWidth; // reiniciar la animación
      sizeGroup.classList.add('is-attention');
      var firstSize = sizeGroup.querySelector('.zs-size:not([aria-disabled="true"])');
      if (firstSize) firstSize.focus({ preventScroll: true });
      return;
    }
    cta.setAttribute('aria-busy', 'true');
    waitFor(inSync, 6000).then(function (ok) {
      if (!ok) {
        cta.removeAttribute('aria-busy');
        hint.textContent = T.retry;
        queueRefresh();
        return;
      }
      closeSheet(true); // cierre inmediato: el cajón del carrito se abre a continuación
      if (!clickMain()) cta.removeAttribute('aria-busy');
    });
  }

  /* ── Panel inferior ──────────────────────────────────────────────────── */
  var lockedByUs = false;
  function lock() {
    if (html.hasAttribute('scroll-lock')) return;
    html.setAttribute('scroll-lock', ''); // mismo bloqueo de scroll que usan los diálogos del tema
    lockedByUs = true;
  }
  function openSheet() {
    if (!mq.matches) return;
    if (sheet.open) {
      // estaba cerrándose (animación): reabrir sin volver a montarlo
      sheet.classList.add('is-open');
      lock();
      return;
    }
    hint.textContent = '';
    refresh();
    renderOptions(true);
    try {
      sheet.showModal();
    } catch (e) {
      return;
    }
    lock();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    });
  }
  function unlock() {
    if (!lockedByUs) return;
    lockedByUs = false;
    var otherModal = Array.prototype.some.call(document.querySelectorAll('dialog[open]'), function (d) {
      return d !== sheet && d.matches(':modal');
    });
    if (!otherModal) html.removeAttribute('scroll-lock');
  }
  function closeSheet(immediate) {
    if (!sheet.open) return;
    sheet.classList.remove('is-open');
    unlock();
    if (immediate || reduceMotion.matches) sheet.close();
    else setTimeout(function () { if (!sheet.classList.contains('is-open')) sheet.close(); }, 260);
  }

  sheet.addEventListener('cancel', function (e) {
    e.preventDefault();
    closeSheet(false);
  });
  sheet.addEventListener('close', function () {
    sheet.classList.remove('is-open');
    unlock();
  });
  sheet.addEventListener('click', function (e) {
    if (e.target === sheet) closeSheet(false); // clic en el fondo oscuro
  });
  root.querySelector('[data-zs-close]').addEventListener('click', function () { closeSheet(false); });
  root.querySelector('[data-zs-guide]').addEventListener('click', function () {
    var trigger = document.querySelector('main .smartsize-trigger');
    closeSheet(true);
    if (trigger) trigger.click(); // guía de tallas de la app SmartSize
  });
  root.querySelector('[data-zs-open]').addEventListener('click', openSheet);
  addBtn.addEventListener('click', addFromBar);
  cta.addEventListener('click', addFromSheet);

  /* ── Escuchar al tema ────────────────────────────────────────────────── */
  // Elección explícita de talla en la ficha (selector del tema o unidades del pack)
  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element) || !t.closest('main') || inCard(t)) return;
      if (t.matches('variant-picker input[type="radio"]')) {
        var p = t.closest('variant-picker');
        if (p && String(p.dataset.productId) === String(data.productId) && Number(t.dataset.fieldsetIndex) === sizeIdx) {
          state.sizeChosen = true;
        }
      } else if (t.matches('[data-zb-slots] select') && SIZE_RE.test(t.getAttribute('aria-label') || '')) {
        state.sizeChosen = true;
      }
      queueRefresh();
    },
    true
  );
  document.addEventListener('variant:update', function (e) {
    var d = e.detail && e.detail.data;
    if (d && d.productId && String(d.productId) !== String(data.productId)) return;
    if (inCard(e.target)) return;
    queueRefresh();
    setTimeout(queueRefresh, 120); // el bloque de precio y los packs se repintan justo después
    setTimeout(observe, 150);
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t instanceof Element && t.closest('main [data-zb]')) setTimeout(queueRefresh, 0);
  });
  // Horizon: cart:add y cart:update son el MISMO evento ('cart:update'). Solo lo escuchamos
  // (fin del estado «añadiendo»); nunca lo disparamos (abriría el cajón por su cuenta).
  document.addEventListener('cart:update', function () { if (state.busy) setBusy(false); });
  document.addEventListener('cart:error', function () { if (state.busy) setBusy(false); });

  // Teclado abierto en móvil (buscador, reseñas…): sin barra.
  // OJO: Klaviyo enfoca por programa un <input> oculto al cargar la página. Solo cuenta el foco
  // que llega justo después de un toque del cliente, en un campo de texto visible.
  var TEXT_FIELDS = 'input:not([type]), input[type="text"], input[type="email"], input[type="search"], input[type="tel"], input[type="number"], input[type="password"], input[type="url"], textarea, [contenteditable="true"]';
  var lastGesture = 0;
  document.addEventListener('pointerdown', function () { lastGesture = Date.now(); }, true);
  function isTyping(t) {
    if (!(t instanceof Element) || root.contains(t) || !t.matches(TEXT_FIELDS)) return false;
    if (Date.now() - lastGesture > 1500) return false; // foco puesto por un script, no por el cliente
    var r = t.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  document.addEventListener('focusin', function (e) {
    state.typing = isTyping(e.target);
    updateVisibility();
  });
  document.addEventListener('focusout', function () {
    if (!state.typing) return;
    setTimeout(function () {
      var a = document.activeElement;
      state.typing = !!(a && a !== document.body && a.matches && a.matches(TEXT_FIELDS) && !root.contains(a));
      updateVisibility();
    }, 50);
  });

  function onMedia() {
    root.hidden = !mq.matches;
    if (!mq.matches) closeSheet(true);
    updateVisibility();
  }
  if (mq.addEventListener) mq.addEventListener('change', onMedia);
  else if (mq.addListener) mq.addListener(onMedia);

  function init() {
    onMedia();
    observe();
    refresh();
    // red de seguridad: si el tema re-renderiza el bloque de compra, volver a observarlo
    var host = productForm();
    host = host && (host.closest('.product-information, .shopify-section') || host.parentElement);
    if (host && window.MutationObserver) {
      new MutationObserver(function () {
        if (observed && !observed.isConnected) {
          observed = null;
          observe();
        }
        queueRefresh();
      }).observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-on', 'disabled'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
